import findIndex from '@babel/runtime-corejs3/core-js-stable/instance/find-index';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var map;

try {
  map = Map;
} catch (_) {}
/* Handling the error is unnecessary. */
// ES6 Set


var set;

try {
  set = Set;
} catch (_) {
  /* Handling the error is unnecessary. */
}

function baseClone(src, circulars, clones, opts) {
  // Null/undefined/functions/etc
  if (!src || _typeof(src) !== 'object' || typeof src === 'function') {
    return src;
  } // DOM Node


  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true);
  } // Date


  if (src instanceof Date) {
    return new Date(src.getTime());
  } // RegExp


  if (src instanceof RegExp) {
    return new RegExp(src);
  } // Arrays


  if (Array.isArray(src)) {
    return src.map(function (i) {
      return clone(i, opts);
    });
  } // ES6 Maps


  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()));
  } // ES6 Sets


  if (set && src instanceof set) {
    return new Set(Array.from(src.values()));
  } // Object


  if (src instanceof Object) {
    circulars.push(src);
    var obj = {};

    if (opts.proto) {
      obj = Object.create(src);
    }

    clones.push(obj);
    Object.keys(src).forEach(function (k) {
      var i = findIndex(circulars).call(circulars, function (i) {
        return i === src[k];
      });
      obj[k] = i > -1 ? clones[i] : baseClone(src[k], circulars, clones, opts);
    });
    return obj;
  } // ???


  return src;
}

function clone(src) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    proto: false
  };
  return baseClone(src, [], [], opts);
}

export default clone;
